export const htmlToText = (html: string): string =>
  new DOMParser().parseFromString(html, 'text/html').body.textContent ?? '';

export const isBodyBlank = (content: string): boolean => htmlToText(content).trim() === '';
